// extracted by mini-css-extract-plugin
module.exports = {"container":"chartResult_container__1Khrc","heading":"chartResult_heading__YzVCU","content":"chartResult_content__1sM5q","item":"chartResult_item__2pUtY"};